<template>
    <div>
        <div v-if="! uploading"
            class="flex-none"
        >
            <input type="file"
                class="hidden invisible w-0 h-0"
                ref="chooseFileButton"
                name="file"
                @change="onFileChange"
            >

            <button v-if="! read_only"
                type="button"
                class="flex flex-none w-full h-full py-1 text-blue-600 hover:text-blue-800 cursor-pointer leading-none items-end outline-none"
                @click="selectFile"
            >
                <div class="text-md font-semibold leading-none text-label">
                    <span class="text-lg mr-0.5 pt-1.5">+</span>

                    {{ $t('Upload a Document') }}
                </div>

                <div class="font-normal text-sm opacity-75 pl-2 pb-0.5">{{ $t('(Maximum 60 MB)') }}</div>
            </button>
        </div>

        <div v-if="file && uploading" class="flex items-center text-blue-600">
            <Spinner class="w-7 h-7 mr-3" />

            {{ $t('Uploading') }} <span class="font-bold ml-2">{{ file.name }}</span> ...
        </div>

        <div v-else-if="error" class="flex items-center text-red-600 pl-8">
            <i class="fas fa-exclamation-triangle mr-3" aria-hidden="true"></i>
            {{ error }}
        </div>
    </div>
</template>

<script>
import Spinner from '../components/spinner.vue';

export default {
    components: {
        Spinner,
    },

    props: {
        store_url: {},
        read_only: { default: false },
        button_size: { default: 'normal' },
        parameters: {},
    },

    data() {
        return {
            file: null,
            error: null,
            uploading: false,
        }
    },

    methods: {
        onFileChange(event) {
            this.error = null;
            this.file = event.target.files[0];

            if (this.file) {
                const size = this.file.size / 1000 / 1000;

                if (size >= 60) {
                    this.error = 'File is too big; please select a file less than 60MB';
                } else {
                    this.saveFile();
                }
            } else {
                window.alert('Please select a file.');
            }
        },
        selectFile() {
            this.$refs.chooseFileButton.click();
        },
        saveFile(){
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('size_mb', this.file.size / 1000 / 1000);

            Object.keys(this.parameters).forEach(key => {
                formData.append(key, this.parameters[key]);
            });

            this.uploading = true;

            axios.post(this.store_url, formData)
                .then(response => {
                    this.uploading = false;
                    this.$emit('uploaded', response.data);
                })
                .catch(error => {
                    this.uploading = false;
                    this.error = error?.response?.data?.message;
                    console.log(error);
                });
        },
    },
}
</script>
